module.exports = __webpack_public_path__ + "img/9788996222699.5e9c740b.jpg";